export default "__VITE_ASSET__Bq$3WyKV__"